import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['5 tomów do wydrukowania', '120 kart projektów krok po kroku', 'Trzy poziomy: Łatwe → Z podpowiedzią → Wyzwanie', 'Materiały, czas, bezpieczeństwo i pomoc dorosłego widoczne na każdej karcie', '5 bonusów w zestawie', 'Dostęp od razu po zakupie', 'Jednorazowa płatność, bez subskrypcji'];
export function ClosingBlock() {
  return <section id="closing" className="w-full scroll-mt-20 bg-foreground px-5 py-14 sm:py-24" data-id="element-65" data-mp="20tnr2rpvltuj">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.5
    }} className="mx-auto flex max-w-2xl flex-col items-center text-center" data-id="element-66" data-mp="1vzjk48gm1ltg">
        <h2 className="font-display text-2xl font-bold leading-tight text-card sm:text-4xl" data-id="element-67" data-mp="1hzqktor0px9v">
          Więcej budowania. Mniej „nudzi mi się”.
        </h2>
        <p className="mt-4 text-base font-semibold text-highlight sm:text-lg" data-id="element-68" data-mp="3ntfxdfzj7eva">
          Pracownia Małego Wynalazcy prowadzi ciekawskie dzieci od pomysłu do gotowego wynalazku.
        </p>

        <ul className="mt-8 grid w-full max-w-md gap-3 text-left" data-id="element-69" data-mp="3slzaycy7ya03">
          {includes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-70" data-mp="3iucw86mo9ssl">
              <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-success/20 text-success" data-id="element-71" data-mp="3iumltt3t1xxr">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-72" data-mp="fdmif5kumbgc" />
              </span>
              <span className="text-sm leading-relaxed text-white/85" data-id="element-73" data-mp="fba3l1ae0h7i">{item}</span>
            </li>)}
        </ul>

        <span className="mt-10 font-display text-[52px] font-bold leading-none text-card sm:text-7xl" data-id="element-74" data-mp="5exbu8yekdfe">
          73 zł
        </span>

        <motion.a href="#get-access" animate={{
        y: [0, -2, 0],
        scale: [1, 1.015, 1]
      }} whileHover={{
        scale: 1.025,
        boxShadow: '0 16px 34px -10px rgba(255, 107, 53, 0.7)'
      }} whileTap={{
        scale: 0.98
      }} transition={{
        y: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        scale: {
          duration: 2.2,
          ease: 'easeInOut',
          repeat: Infinity
        },
        type: 'spring',
        stiffness: 400,
        damping: 22
      }} className="mt-9 flex min-h-[58px] w-full max-w-md items-center justify-center rounded-button bg-accent px-6 py-4 text-base font-extrabold tracking-tight text-card shadow-lg shadow-accent/40 sm:text-lg" data-id="element-75" data-mp="2l5tcssfwq67e">
          CHCĘ PRACOWNIĘ MAŁEGO WYNALAZCY
        </motion.a>
        <p className="mt-3 text-xs text-white/60" data-id="element-76" data-mp="3zcf9l7ou9e8">Pobierasz od razu · Płacisz raz</p>
        <p className="mt-4 max-w-md text-[11px] leading-relaxed text-white/50" data-id="element-77" data-mp="3v5dw6aec3x7s">
          Klikając „Kupuję”, zgadzasz się na dostarczenie plików od razu po płatności. Przy
          treściach cyfrowych oznacza to utratę prawa do odstąpienia od umowy w ciągu 14 dni.
        </p>
      </motion.div>
    </section>;
}